import styled from 'styled-components';
import { EERIE, GREAT_WHITE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
const DisplayResultsText = styled(FormattedMessage).withConfig({
  displayName: "DisplayResultsText",
  componentId: "sc-14p2ndx-0"
})(["padding-top:8px;padding-bottom:8px;display:flex;justify-content:center;text-align:center;font-style:italic;color:", ";border-bottom:solid 1px ", ";"], EERIE, GREAT_WHITE);
export default DisplayResultsText;